export const WORKSPACE_CALENDAR_COLORS = [
    { id: "berry", label: "Berry", value: "berry", swatch: "#f26d9b" },
    { id: "ocean", label: "Ocean", value: "ocean", swatch: "#5ab8ff" },
    { id: "lime", label: "Lime", value: "lime", swatch: "#7ed957" },
    { id: "amber", label: "Amber", value: "amber", swatch: "#f2a365" },
    { id: "violet", label: "Violet", value: "violet", swatch: "#b48ef2" },
    { id: "cobalt", label: "Cobalt", value: "cobalt", swatch: "#4c6fff" },
];

export const VIBRANT_CALENDAR_COLORS = [
    { id: "sunset", label: "Sunset", value: "#ff7a59", swatch: "#ff7a59" },
    { id: "lagoon", label: "Lagoon", value: "#1ec6b6", swatch: "#1ec6b6" },
    { id: "orchid", label: "Orchid", value: "#c77dff", swatch: "#c77dff" },
    { id: "midnight", label: "Midnight", value: "#344966", swatch: "#344966" },
    { id: "citrine", label: "Citrine", value: "#f6d743", swatch: "#f6d743" },
    { id: "rose", label: "Rose", value: "#ff4d6d", swatch: "#ff4d6d" },
];

export const CALENDAR_COLOR_GROUPS = [
    { title: "Workspace palette", items: WORKSPACE_CALENDAR_COLORS },
    { title: "Vibrant picks", items: VIBRANT_CALENDAR_COLORS },
];

export const CALENDAR_COLOR_TOKEN_MAP = WORKSPACE_CALENDAR_COLORS.reduce((accumulator, item) => {
    accumulator[item.value] = item.swatch;
    return accumulator;
}, {});

const HEX_COLOR_PATTERN = /^#?[0-9a-f]{3}([0-9a-f]{3})?$/i;

export const resolveCalendarColor = (input) => {
    if (!input || typeof input !== "string") {
        return null;
    }
    const trimmed = input.trim();
    if (!trimmed) {
        return null;
    }
    if (HEX_COLOR_PATTERN.test(trimmed)) {
        return trimmed.startsWith("#") ? trimmed : `#${trimmed}`;
    }
    return CALENDAR_COLOR_TOKEN_MAP[trimmed] || null;
};
